module.exports = __webpack_public_path__ + "static/Snowball X Privacy Policy v6.0-a94a81ce561dfbfa8b6ce5adf54ee489.pdf";